import { set } from 'lodash';
import { ItemResource } from './item.resource';
import { ItemStatus } from './item.constants';
class ItemService {
    constructor() {
        this.itemResource = new ItemResource();
    }
    create(item, files = []) {
        this.replacePropValuesForFiles(item, files);
        return this.itemResource.create(item, files);
    }
    update(item, files = []) {
        this.replacePropValuesForFiles(item, files);
        return this.itemResource.update(item, files);
    }
    updateStatus(itemId, status, reportDate) {
        return this.itemResource.updateStatus(itemId, status, reportDate);
    }
    remove(itemId) {
        return this.itemResource.remove(itemId);
    }
    createDefaultItem(project, category) {
        const defaultItem = {
            title: '',
            image: '',
            url: '',
            project,
            category,
            details: {},
            status: ItemStatus.CANDIDATE,
        };
        return defaultItem;
    }
    createDefaultFeaturedItem(project, category) {
        const defaultFeaturedItem = {
            title: '',
            image: '',
            url: '',
            project,
            category,
            details: {},
            status: ItemStatus.FEATURED_DISABLED,
        };
        return defaultFeaturedItem;
    }
    replacePropValuesForFiles(item, files) {
        if (!files || !files.length) {
            return;
        }
        files.forEach((file) => {
            const propPath = file.name.split('___')[0];
            set(item, propPath, '___PLACEHOLDER___');
        });
    }
    getItemCountOnQueue(project, category) {
        return this.itemResource.getItemCountOnQueue(project, category);
    }
    getSourcesWithCandidateItemCounts(project, category) {
        return this.itemResource.getSourcesWithCandidateItemCounts(project, category);
    }
    getList(params) {
        if (params.status !== ItemStatus.REPORT) {
            delete params.date;
        }
        if (params.status !== ItemStatus.CANDIDATE) {
            delete params.source;
        }
        return this.itemResource.getList(params);
    }
    getUpdatedAt(project, category, source) {
        return this.itemResource.getItemUpdatedAt(project, category, source);
    }
    getBatch(itemIds) {
        return this.itemResource.getBatch(itemIds);
    }
    getOldReportItem(project, url) {
        return this.itemResource.getOldItemForReport(project, url);
    }
}
export default new ItemService();
